module.exports = __webpack_public_path__ + "static/media/bmw.7ac38bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/bmw/bmw.jpg
// module id = 737
// module chunks = 0